import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const deleteTeamAppsTE = <E = CF.API.ApiError>(
  { orgId, teamId, body }: { orgId: string; teamId: string; body: { app_ids: string[] } },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/teams/${teamId}/apps`,
      method: 'DELETE',
      body,
    },
    onRejected,
  );
